// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  ContentStudioMaterializeRequest,
  ContentStudioStage1Request,
  ContentStudioStage1Response,
  ContentStudioStage2Request,
  ContentStudioStage2Response,
  ContentStudioStage3Request,
  ContentStudioStage3Response,
  GenericApiResponseModuleLecturerResponse,
  HTTPValidationError,
} from '../../models';

/**
 * Stage 1: Concept Cartography.
Input: Topic and resources.
Output: Concept Graph and Scoping Questions.
 * @summary Process Stage 1
 */
export const processStage1ContentStudioStage1Post = (
  contentStudioStage1Request: ContentStudioStage1Request,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ContentStudioStage1Response>> => {
  return axios.post(`/content-studio/stage1`, contentStudioStage1Request, options);
};

export const getProcessStage1ContentStudioStage1PostMutationOptions = <
  TData = Awaited<ReturnType<typeof processStage1ContentStudioStage1Post>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: ContentStudioStage1Request }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['processStage1ContentStudioStage1Post'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof processStage1ContentStudioStage1Post>>,
    { data: ContentStudioStage1Request }
  > = (props) => {
    const { data } = props ?? {};

    return processStage1ContentStudioStage1Post(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: ContentStudioStage1Request },
    TContext
  >;
};

export type ProcessStage1ContentStudioStage1PostMutationResult = NonNullable<
  Awaited<ReturnType<typeof processStage1ContentStudioStage1Post>>
>;
export type ProcessStage1ContentStudioStage1PostMutationBody = ContentStudioStage1Request;
export type ProcessStage1ContentStudioStage1PostMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Process Stage 1
 */
export const useProcessStage1ContentStudioStage1Post = <
  TData = Awaited<ReturnType<typeof processStage1ContentStudioStage1Post>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: ContentStudioStage1Request }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: ContentStudioStage1Request }, TContext> => {
  const mutationOptions = getProcessStage1ContentStudioStage1PostMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Stage 2: Scope Refinement.
Input: Selected concepts (scope) and answers to scoping questions.
Output: Strategy Questions.
 * @summary Process Stage 2
 */
export const processStage2ContentStudioStage2Post = (
  contentStudioStage2Request: ContentStudioStage2Request,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ContentStudioStage2Response>> => {
  return axios.post(`/content-studio/stage2`, contentStudioStage2Request, options);
};

export const getProcessStage2ContentStudioStage2PostMutationOptions = <
  TData = Awaited<ReturnType<typeof processStage2ContentStudioStage2Post>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: ContentStudioStage2Request }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['processStage2ContentStudioStage2Post'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof processStage2ContentStudioStage2Post>>,
    { data: ContentStudioStage2Request }
  > = (props) => {
    const { data } = props ?? {};

    return processStage2ContentStudioStage2Post(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: ContentStudioStage2Request },
    TContext
  >;
};

export type ProcessStage2ContentStudioStage2PostMutationResult = NonNullable<
  Awaited<ReturnType<typeof processStage2ContentStudioStage2Post>>
>;
export type ProcessStage2ContentStudioStage2PostMutationBody = ContentStudioStage2Request;
export type ProcessStage2ContentStudioStage2PostMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Process Stage 2
 */
export const useProcessStage2ContentStudioStage2Post = <
  TData = Awaited<ReturnType<typeof processStage2ContentStudioStage2Post>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: ContentStudioStage2Request }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: ContentStudioStage2Request }, TContext> => {
  const mutationOptions = getProcessStage2ContentStudioStage2PostMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Stage 3: Module Generation.
Input: Strategy answers.
Output: Module Draft.
 * @summary Process Stage 3
 */
export const processStage3ContentStudioStage3Post = (
  contentStudioStage3Request: ContentStudioStage3Request,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ContentStudioStage3Response>> => {
  return axios.post(`/content-studio/stage3`, contentStudioStage3Request, options);
};

export const getProcessStage3ContentStudioStage3PostMutationOptions = <
  TData = Awaited<ReturnType<typeof processStage3ContentStudioStage3Post>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: ContentStudioStage3Request }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['processStage3ContentStudioStage3Post'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof processStage3ContentStudioStage3Post>>,
    { data: ContentStudioStage3Request }
  > = (props) => {
    const { data } = props ?? {};

    return processStage3ContentStudioStage3Post(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: ContentStudioStage3Request },
    TContext
  >;
};

export type ProcessStage3ContentStudioStage3PostMutationResult = NonNullable<
  Awaited<ReturnType<typeof processStage3ContentStudioStage3Post>>
>;
export type ProcessStage3ContentStudioStage3PostMutationBody = ContentStudioStage3Request;
export type ProcessStage3ContentStudioStage3PostMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Process Stage 3
 */
export const useProcessStage3ContentStudioStage3Post = <
  TData = Awaited<ReturnType<typeof processStage3ContentStudioStage3Post>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: ContentStudioStage3Request }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: ContentStudioStage3Request }, TContext> => {
  const mutationOptions = getProcessStage3ContentStudioStage3PostMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Final Stage: Materialize the drafted module into actual DB records.
 * @summary Materialize
 */
export const materializeContentStudioMaterializePost = (
  contentStudioMaterializeRequest: ContentStudioMaterializeRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModuleLecturerResponse>> => {
  return axios.post(`/content-studio/materialize`, contentStudioMaterializeRequest, options);
};

export const getMaterializeContentStudioMaterializePostMutationOptions = <
  TData = Awaited<ReturnType<typeof materializeContentStudioMaterializePost>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: ContentStudioMaterializeRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['materializeContentStudioMaterializePost'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof materializeContentStudioMaterializePost>>,
    { data: ContentStudioMaterializeRequest }
  > = (props) => {
    const { data } = props ?? {};

    return materializeContentStudioMaterializePost(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: ContentStudioMaterializeRequest },
    TContext
  >;
};

export type MaterializeContentStudioMaterializePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof materializeContentStudioMaterializePost>>
>;
export type MaterializeContentStudioMaterializePostMutationBody = ContentStudioMaterializeRequest;
export type MaterializeContentStudioMaterializePostMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Materialize
 */
export const useMaterializeContentStudioMaterializePost = <
  TData = Awaited<ReturnType<typeof materializeContentStudioMaterializePost>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: ContentStudioMaterializeRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: ContentStudioMaterializeRequest }, TContext> => {
  const mutationOptions = getMaterializeContentStudioMaterializePostMutationOptions(options);

  return useMutation(mutationOptions);
};
